// src/modules/units/tyres/shared/tyre-dates.js
//
// The module's <input type="date"> ↔ action-timestamp convention, in one place.
// Every action-capture path (rotation, the Inspect/Repair/Retire form, and retread
// dispatch/receive) used to carry its own copy of these two helpers; they now share
// this one so the rule can't drift between screens.
//
// A tyre action is recorded against a DAY, not a wall-clock moment — the forms
// collect a date, never a time. These helpers bridge that date to the ISO timestamp
// the API stores:
//
//   todayInputValue()      today's date as an <input type="date"> value — LOCAL, so
//                          it matches the field the user sees (and is the value the
//                          forms use as the default and as `max`).
//
//   isoFromDateInput(v)    the chosen date as an ISO timestamp to POST:
//                            • today      → the real current time, so a same-day
//                              action sorts against other same-day events by when it
//                              actually happened;
//                            • any other  → LOCAL NOON, which never slips to the
//                              previous day when the timestamp is read back as UTC.
//                          A blank or unparseable value returns `undefined`, so a
//                          caller whose date is OPTIONAL (retread dispatch/receive)
//                          just omits the field and lets the backend stamp it. Callers
//                          that require a date guard the input before calling, so they
//                          never see the undefined.
//
// NOTE: the timeline deliberately shows only the DAY (see tyredetail.view.js), so the
// noon placeholder is never rendered as a clock time.

export function todayInputValue() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function isoFromDateInput(value) {
  if (!value) return undefined;
  if (value === todayInputValue()) return new Date().toISOString();
  const [y, m, d] = String(value).split('-').map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d, 12, 0, 0).toISOString();
}
